module.exports = __webpack_public_path__ + "static/img/新火箭(1)0041.b4aa26c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rocket/新火箭(1)0041.png
// module id = bQVP
// module chunks = 1